import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TransactionOverview = ({ transaction }) => {
  const getTRLColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const getTRLBgColor = (score) => {
    if (score >= 80) return 'bg-success/10';
    if (score >= 60) return 'bg-warning/10';
    return 'bg-error/10';
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-soft">
      <div className="p-6">
        <div className="flex items-start justify-between mb-6">
          <div>
            <h2 className="text-2xl font-semibold text-foreground mb-2">{transaction?.propertyName}</h2>
            <p className="text-muted-foreground">{transaction?.address}</p>
            <div className="flex items-center space-x-4 mt-3">
              <span className="text-sm text-muted-foreground">Transaction ID:</span>
              <span className="font-mono text-sm text-foreground">{transaction?.id}</span>
              <div className="flex items-center space-x-1">
                <Icon name="Shield" size={14} className="text-success" />
                <span className="text-xs text-success">Blockchain Verified</span>
              </div>
            </div>
          </div>
          
          <div className="text-right">
            <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
              transaction?.status === 'In Progress' ? 'bg-warning/10 text-warning' :
              transaction?.status === 'Completed'? 'bg-success/10 text-success' : 'bg-muted text-muted-foreground'
            }`}>
              <div className={`w-2 h-2 rounded-full mr-2 ${
                transaction?.status === 'In Progress' ? 'bg-warning animate-pulse' :
                transaction?.status === 'Completed'? 'bg-success' : 'bg-muted-foreground'
              }`} />
              {transaction?.status}
            </div>
            <p className="text-sm text-muted-foreground mt-2">Started {transaction?.startDate}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Property Image */}
          <div className="lg:col-span-1">
            <div className="aspect-video rounded-lg overflow-hidden bg-muted">
              <Image 
                src={transaction?.propertyImage} 
                alt={transaction?.propertyName}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Transaction Details */}
          <div className="lg:col-span-2 space-y-6">
            {/* TRL Score */}
            <div className={`p-4 rounded-lg ${getTRLBgColor(transaction?.trlScore)}`}>
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-medium text-foreground">Transaction Readiness Level (TRL)</h3>
                <span className={`text-2xl font-bold ${getTRLColor(transaction?.trlScore)}`}>
                  {transaction?.trlScore}%
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2 mb-3">
                <div 
                  className={`h-2 rounded-full transition-all duration-500 ${
                    transaction?.trlScore >= 80 ? 'bg-success' :
                    transaction?.trlScore >= 60 ? 'bg-warning' : 'bg-error'
                  }`}
                  style={{ width: `${transaction?.trlScore}%` }}
                />
              </div>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="text-muted-foreground">Documents:</span>
                  <span className="ml-2 font-medium text-foreground">
                    {transaction?.completedDocuments}/{transaction?.totalDocuments}
                  </span>
                </div>
                <div>
                  <span className="text-muted-foreground">Signatures:</span>
                  <span className="ml-2 font-medium text-foreground">
                    {transaction?.completedSignatures}/{transaction?.totalSignatures}
                  </span>
                </div>
              </div>
            </div>

            {/* Property Information */}
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-3">
                <div>
                  <span className="text-sm text-muted-foreground">Property Type</span>
                  <p className="font-medium text-foreground">{transaction?.propertyType}</p>
                </div>
                <div>
                  <span className="text-sm text-muted-foreground">Square Footage</span>
                  <p className="font-medium text-foreground">{transaction?.squareFootage} sq ft</p>
                </div>
                <div>
                  <span className="text-sm text-muted-foreground">Year Built</span>
                  <p className="font-medium text-foreground">{transaction?.yearBuilt}</p>
                </div>
              </div>
              <div className="space-y-3">
                <div>
                  <span className="text-sm text-muted-foreground">Transaction Value</span>
                  <p className="font-medium text-foreground">{transaction?.value}</p>
                </div>
                <div>
                  <span className="text-sm text-muted-foreground">Token Supply</span>
                  <p className="font-medium text-foreground">{transaction?.tokenSupply} tokens</p>
                </div>
                <div>
                  <span className="text-sm text-muted-foreground">Expected Completion</span>
                  <p className="font-medium text-foreground">{transaction?.expectedCompletion}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionOverview;